import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const CategoryNavigation = () => {
  const { subNavigation } = useTypedSelector(
    (state) => state.productFiltering
  );
  let currentCategory = subNavigation;
  let subCategories = subNavigation?.links;
  let foundCategory;

  while (currentCategory.links?.length > 0) {
    subCategories = currentCategory.links;
    foundCategory = currentCategory.links.find(
      (l) => l.isSelected == true
    );
    if (!foundCategory || foundCategory.links?.length === 0) {
      break;
    } else {
      currentCategory = foundCategory;
    }
  }
  return (
    <div className="hidden flex-col text-md lg:block">
      <div className="py-3 font-bold">
        {foundCategory ? (
          <a href={currentCategory.url}>{currentCategory.name}</a>
        ) : (
          currentCategory.name
        )}
      </div>
      <ul className="flex flex-col gap-2 border-b border-solid border-gray-300 pb-4">
        {subCategories
          .sort((a, b) => a.name?.localeCompare(b.name))
          .map((link, idx) => (
            <li
              className={clsx(
                foundCategory &&
                  foundCategory.url == link.url &&
                  'pointer-events-none font-bold',
                'flex'
              )}
              key={link.url + idx}
            >
              <a className="flex-1" href={link.url}>
                {link.name}
              </a>{' '}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default CategoryNavigation;
